/* eslint-disable no-unused-vars */
import React from 'react';
import { DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import Dialog from '../Basic/Dialog';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 14,
    color: 'var(--color-fontColors-grey-2)',
    fontWeight: 400,
    letterSpacing: '-0.116667px',
    lineHeight: '1.571',

    '& .MuiDialog-paper': {
      [theme.breakpoints.up('md')]: {
        maxWidth: '356px',
      },
    },

    '& .MuiDialogActions-root': {
      '& button': {
        marginRight: theme.spacing(1),

        '&:first-child': {
          minWidth: 115,
        },

        '&:last-child': {
          marginRight: 0,
        },
      },
    },

    '& b': {
      fontWeight: 500,
    },
  },
}));

function SimpleModal({
  open = false,
  onClose = () => {},
  className = '',
  title = '',
  children = '',
  elevation = 2,
  controlChildren = '',
  ...restProps
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={`${classes.root} simple-modal ${className}`}
      {...restProps}
    >
      {title ? <DialogTitle>{title}</DialogTitle> : ''}
      <DialogContent>{children}</DialogContent>
      {controlChildren ? <DialogActions>{controlChildren}</DialogActions> : ''}
    </Dialog>
  );
}

export default SimpleModal;
